module.exports = __webpack_public_path__ + "img/IE.b412c70a.png";